"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkIfScreenHasOnOffTimer = void 0;
const checkIfScreenHasOnOffTimer = (screen) => {
    var _a, _b, _c, _d, _e, _f;
    const onTimersLength = (_c = (_b = (_a = screen.configs) === null || _a === void 0 ? void 0 : _a.onOffTimer) === null || _b === void 0 ? void 0 : _b.onTimers) === null || _c === void 0 ? void 0 : _c.length;
    if (onTimersLength && onTimersLength > 0) {
        return true;
    }
    const offTimersLength = (_f = (_e = (_d = screen.configs) === null || _d === void 0 ? void 0 : _d.onOffTimer) === null || _e === void 0 ? void 0 : _e.offTimers) === null || _f === void 0 ? void 0 : _f.length;
    if (offTimersLength && offTimersLength > 0) {
        return true;
    }
    return false;
};
exports.checkIfScreenHasOnOffTimer = checkIfScreenHasOnOffTimer;
//# sourceMappingURL=screens.js.map